import List from '@mui/material/List';
import CommentListItem from './CommentListItem';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import axios from 'axios';

export default function CommentComponent(props) {
  const { kind, boardId } = props;
  const [datas, setDatas] = useState({});
  const [list, setlist] = useState([{}]);
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty }
  } = useForm({});

  const auth = useRecoilValue(authAtom);

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const registerComment = async (data) => {
    data.datas.kind = kind;
    data.datas.boardId = boardId;
    data.datas.createdId = auth.userid;
    return await axios.post(`/api/comment`, data.datas);
  };

  const onSubmit = async (data) => {
    await registerComment(data)
      .then((response) => {
        alert(response.data.message);
        getComment();
        setDatas({});
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getComment = async () => {
    let params = { kind, boardId };
    const response = await axios.get(`/api/comment`, { params });
    await setlist(response.data);
  };

  useEffect(async () => {
    await getComment();
  }, []);

  return (
    <>
      {auth && <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
        <TextField
          id="comment"
          variant="outlined"
          label="댓글"
          multiline
          sx={{ width: 3 / 5 - 1 / 6, minWidth: 350, ml: 1 }}
          value={datas?.comment || ''}
          error={!!errors.datas?.comment}
          helperText={errors.datas?.comment && errors.datas?.comment.message}
          {...register('datas.comment', {
            required: '댓글을 입력해주세요.',
            maxLength: { value: 200, message: '댓글은 200자 이하입니다.' }
          })}
          onChange={handleChange}
        />
        <Button type="submit" sx={{ width: 1 / 6, height: 54, ml: 1 }} variant="contained" size="large">
          등록
        </Button>
      </Box>}
      <List sx={{ width: 3 / 5, minWidth: 350, bgcolor: 'background.paper' }}>
        {list.map((comment, index) => {
          return (
            <>
              <CommentListItem comment={comment} getComment={getComment} registerComment={registerComment} />
            </>
          );
        })}
      </List>
    </>
  );
}
